module.exports = __webpack_public_path__ + "img/qrcode.c516f8bc.jpg";